module.exports = __webpack_public_path__ + "img/2019homepark-5.5a8560c6.jpeg";